import { type FC } from 'react';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { AiBadge } from 'src/modules/shared/components/atoms/indicators/ai-badge';
import { Text } from 'src/modules/shared/components/atoms/text';
import { classes } from 'src/modules/shared/utils/styles.util';
import { PiArrowsInCardinal, PiArrowsOutCardinal } from 'react-icons/pi';

interface AiStatusesRailToggleProps {
  hasAiStatuses: boolean;
  isCollapsed: boolean;
  label: string;
  onClick: () => void;
}

const collapsedRailOuterClasses = 'flex-none w-[48px] h-full mx-2 pb-2';
const collapsedRailInnerClasses =
  'flex h-full flex-col items-center rounded-xl border px-2 py-3 shadow-sm transition-colors';

export const AiStatusesRailToggle: FC<AiStatusesRailToggleProps> = ({
  hasAiStatuses,
  isCollapsed,
  label,
  onClick,
}) => {
  return (
    <div className={collapsedRailOuterClasses}>
      <Button
        variant="secondary"
        appearance="ghost"
        onClick={onClick}
        aria-label={label}
        className={classes(
          collapsedRailInnerClasses,
          '!h-full w-full border-dashed border-secondary-200/80 bg-secondary-50/60 hover:bg-secondary-100/70'
        )}
      >
        <div className="flex flex-col items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-md text-secondary-500">
            {isCollapsed ? (
              <PiArrowsOutCardinal className="h-[18px] w-[18px] text-secondary-500" />
            ) : (
              <PiArrowsInCardinal className="h-[18px] w-[18px] text-secondary-500" />
            )}
          </div>

          {hasAiStatuses && (
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <AiBadge size="md" variant="neutral" appearance="filled" />
            </div>
          )}
        </div>

        <div className="flex flex-1 items-center justify-center py-4">
          <Text
            size="small"
            weight="medium"
            className="text-center text-secondary-700 [writing-mode:vertical-rl] rotate-180 line-clamp-none"
          >
            {label}
          </Text>
        </div>
      </Button>
    </div>
  );
};
